import styles from "./CashFlowStatementTable.module.scss";

export const getCashFlowStatementCellClassName = ({
    isTotal,
    isSummary,
}: {
    isTotal: boolean;
    isSummary: boolean;
}): string | undefined => {
    if (isTotal) {
        return styles.totalCell;
    }
    if (isSummary) {
        return styles.summaryCell;
    }
    return undefined;
};
